import React, { Component } from "react";
import portfolioData from "../../data/mainData.json";

class PortfolioV1 extends Component {
  render() {
    const publicUrl = process.env.PUBLIC_URL + "/";
    const gallery = portfolioData.gallery;

    return (
      <div className="ltn__gallery-area ">
        <div className="container">

          {/* Title */}
          <div className="row">
            <div className="col-lg-12 text-center">
              <h1 className="section-title ltn__secondary-color">Gallery</h1>
            </div>
          </div>

          {/* ===== ROW 1 ===== */}
          <div className="row mb-4">

            {/* Left Large Image */}
            <div className="col-md-8 col-12 mb-3 mb-md-0">
              <img
                src={gallery[0]?.image}
                alt="Gallery"
                className="img-fluid w-100 h-100"
              />
            </div>

            {/* Right Two Vertical Images */}
            <div className="col-md-4 col-12">
              <div className="mb-3">
                <img
                  src={gallery[1]?.image}
                  alt="Gallery"
                  className="img-fluid w-100"
                />
              </div>
              <div>
                <img
                  src={gallery[2]?.image}
                  alt="Gallery"
                  className="img-fluid w-100"
                />
              </div>
            </div>

          </div>

           <div className="row">
            {gallery.slice(3, 6).map((item, index) => (
              <div key={index} className="col-md-4 col-sm-6 col-12 mb-3">
                <img
                  src={item.image}
                  alt="Gallery"
                  className="img-fluid w-100"
                />
              </div>
            ))}
          </div>

        </div>
      </div>
    );
  }
}

export default PortfolioV1;
